<div
  class="table-elevated table-responsive table-shadow relative !z-0 max-h-fit w-fit max-w-full overflow-x-scroll whitespace-nowrap no-scrollbar"
>
  <table class="w-auto cursor-pointer" cft-table [dataSource]="tableContent" recycleRows>
    @for (col of columns; track col; let first = $first) {
      <ng-container [cftColumnDef]="col" [sticky]="first" [stickyBackground]="true">
        <th
          cft-header-cell
          *cftHeaderCellDef
          class="text-fit grid-divider bg-grey-0 text-[16px] leading-[140%] text-president-100"
        >
          {{ col }}
        </th>
        <td cft-cell *cftCellDef="let entry" class="grid-divider !text-wrap break-words align-text-top">
          {{ entry[col] }}
        </td>
      </ng-container>
    }
    <tr cft-header-row *cftHeaderRowDef="columns" class="!bg-grey-10"></tr>
    <tr cft-row *cftRowDef="let entry; columns: columns"></tr>
  </table>
</div>
